import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { ApiService } from '../../services/api.service';

import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { UntypedFormControl, Validators } from '@angular/forms';

import { HttpErrorResponse } from '@angular/common/http';

import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { RegisterService } from 'src/app/services/register.service';
import { Router } from '@angular/router';

@Component({
    selector: 'sd-upgrade-account-dialog',
    templateUrl: './upgrade-account-dialog.component.html',
    styleUrls: ['./upgrade-account-dialog.component.scss']
})

export class UpgradeAccountDialogComponent implements OnInit {

    genres = [];
    artistTypes = [];
    countries = [];
    states = [];
    cities = [];

    registerForm: UntypedFormGroup;
    registerError: Boolean = false;
    registerErrorMsg = '';
    registerLoading: Boolean = false;
    formSubmit: boolean=false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<UpgradeAccountDialogComponent>,
        private api: ApiService,
        public user: UserService,
        private el: ElementRef,
        public register: RegisterService,
        private router: Router,
        public global: GlobalService
    ) {
        this.registerForm = new UntypedFormGroup ({
            fname: new UntypedFormControl(this.user.fname, [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                this.validSongTitle.bind(this)
            ]),
            is_type:new UntypedFormControl('Artist',Validators.required),
            // lname: new FormControl(this.user.lname, [
            //     Validators.maxLength(50)
            // ]),
            email: new UntypedFormControl(this.user.email, [
                Validators.required,
                Validators.email,
                Validators.pattern(this.global.emailRegex)
            ]),
            username: new UntypedFormControl(this.user.slug, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(50),
                this.validSongTitle.bind(this)
            ]),
            // genre: new FormControl('', [
            //     Validators.required
            // ]),
            mobile: new UntypedFormControl(this.user.mobile, [
                this.validMobile.bind(this),
                Validators.required

            ]),
            // country: new FormControl('', [
            //     Validators.required
            // ]),
            // state: new FormControl('', [
            //     Validators.required
            // ]),
            // otherState: new FormControl('Other', [
            //     Validators.required
            // ]),
            // city: new FormControl('', [
            //     Validators.required
            // ]),
            // otherCity: new FormControl('', [
            //     Validators.required
            // ]),
            // artistType: new FormControl('', [
            //     this.validArtistTypes.bind(this)
            // ])
        });

        this.getGenres();
        this.getCountries();
        this.getArtistCat();
    }

    get fname() { return this.registerForm.get('fname'); }
    // get lname() { return this.registerForm.get('lname'); }
    get email() { return this.registerForm.get('email'); }
    get mobile() { return this.registerForm.get('mobile'); }
    get username() { return this.registerForm.get('username'); }
    get genre() { return this.registerForm.get('genre'); }
    get country() { return this.registerForm.get('country'); }
    get state() { return this.registerForm.get('state'); }
    get otherState() { return this.registerForm.get('otherState'); }
    get city() { return this.registerForm.get('city'); }
    get otherCity() { return this.registerForm.get('otherCity'); }
    // get artistType() { return this.registerForm.get('artistType'); }

    ngOnInit() {
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onRegisterFormSubmit() {
        // if ( this.registerForm.value.state == 'Other' && this.registerForm.value.otherCity != '' ) {
        //     this.registerForm.patchValue({city: 'Other'});
        // }
        // if ( this.registerForm.value.city == '' && this.registerForm.value.otherCity != '' ) {
        //     this.registerForm.patchValue({city: 'Other'});
        // }
        // if ( this.registerForm.value.city != '' && this.registerForm.value.city != 'Other' && this.registerForm.value.otherCity == '' ) {
        //     this.registerForm.patchValue({otherCity: this.registerForm.value.city});
        // }

        // console.log(this.registerForm.value);
        console.log(this.registerForm.value);
        this.formSubmit = true;
        if (this.registerForm.valid) {
            this.registerLoading = true;

            this.global.trackEvent('Update_Form', 'Process', 'Update CTA');

            console.log(this.registerForm.value);
            this.api.convertToArtistV2(
                this.registerForm.value.genre,
                this.registerForm.value.artistType,
                this.registerForm.value.fname,
                this.registerForm.value.lname,
                this.registerForm.value.mobile,
                this.registerForm.value.email,
                this.registerForm.value.username,
                this.registerForm.value.country,
                (this.registerForm.value.state=='Other') ? this.registerForm.value.otherState : this.registerForm.value.state,
                (this.registerForm.value.city=='Other') ? this.registerForm.value.otherCity : this.registerForm.value.city
            ).subscribe(res => {
                console.log('Reg Response: ', res);

                if ( res.success ) {
                    // console.log('successfully ypgraded!');

                    this.global.trackEvent('Update_Form', 'Process', 'Success');

                    this.user.type = 'Artist';
                    this.user.status = 1;


                    if ( this.user.status == 1 || this.user.status == 2 ) {
                        this.global.activeNavTabs = 'dashboard';
                    } else {
                        this.global.activeNavTabs = '';
                    }

                    this.closeDialog();
                } else {
                    this.registerLoading = false;
                    this.registerError = true;
                    this.registerErrorMsg = res.error;

                    this.global.trackEvent('Update_Form', 'Process', this.registerErrorMsg);
                }
            },
            (err: HttpErrorResponse) => {
                this.registerLoading = false;
                this.registerError = true;

                if (err.error instanceof Error) {
                    this.registerErrorMsg = 'Client-side error occured!';
                    // console.log('Client-side error occured!');
                } else {
                    this.registerErrorMsg = 'Server-side error occured!';
                    // console.log('Server-side error occured!');
                }
            });
        } else {
            const target = this.el.nativeElement.querySelector('.registerForm .ng-invalid');
            if (target) {
                this.global.scrollToElem('.registerForm .ng-invalid');
            }
        }
    }

    getGenres() {
        this.api.getGenres().subscribe(res => {
            // console.log(res);
            this.genres = res;
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }
        });
    }
    getArtistCat() {
        this.api.getArtistCat().subscribe(res => {
            // console.log(res);
            res.forEach(type => {
                this.artistTypes.push(type.name);
            });
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }
        });
    }

    getCountries() {
        this.api.getCountries().subscribe(res => {
            // console.log(res);
            this.countries = res;
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }
        });
    }
    getCities(state) {
        this.api.getCities(state).subscribe(res => {
            this.cities = res;
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured');
            } else {
                // console.log('Server-side error occured', err);
            }
        });
    }

    countryChanged() {
        if ( this.registerForm.value.country == '' ) {
            this.states = [];
        } else {
            this.countries.forEach(country => {
                if ( country.name == this.registerForm.value.country ) {
                    this.states = country.states;
                }
            });
        }

        // console.log('country changed');
        // console.log(this.states);
    }

    stateChanged() {
        if ( this.registerForm.value.state == '' ) {
            this.cities = [];
        } else {
            this.cities = [];
            this.states.forEach(state => {
                if ( state.name == this.registerForm.value.state ) {
                    this.getCities(state.id);
                }
            });
        }

        // console.log('state changed');
        // console.log(this.cities);
    }

    validMobile(control: AbstractControl): { [key: string]: boolean } | null {
        if ( control.value != null && control.value.length > 0 && control.value.length != 10 ) {
            return { 'validMobile': true };
        } else if ( isNaN(control.value) ) {
            return { 'validMobile': true };
        }

        return null;
    }

    validArtistTypes(control: AbstractControl): { [key: string]: boolean } | null {
        if ( control.value.length > 3 ) {
            return { 'validArtistTypes': true };
        }
        return null;
    }
    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    validSongTitle(control: AbstractControl): { [key: string]: boolean } | null {
        let value;
        if ( control.value != null ) {
            value = control.value.trim();
        } else {
            value = '';
        }

        if ( value == '' ) {
            return { 'validSongTitle': true };
        } else if ( !this.global.trackTitleRegex.test(control.value) ) {
            return { 'validSongTitle': true };
        }
        return null;
    }
}
